
function bindProductDescriptionToggles(scope) {
  const root = scope && scope.querySelector ? scope : document;

  root.querySelectorAll('[data-product-description-toggle]').forEach((btn) => {
    if (btn.hasAttribute('data-description-toggle-bound')) return;
    btn.setAttribute('data-description-toggle-bound', '');

    const rootId = btn.getAttribute('data-product-description-root');
    const container = rootId
      ? document.getElementById(rootId)
      : btn.closest('[data-product-description]');

    if (!container) return;

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const expanding = !container.classList.contains('product-description--expanded');

      if (expanding) {
        container.classList.add(
          'product-description',
          'product-description--collapsible',
          'product-description--expanded'
        );
      } else {
        container.classList.remove('product-description--expanded');
      }
    });
  });
}

function initProductDescriptionToggles() {
  bindProductDescriptionToggles(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductDescriptionToggles);
} else {
  initProductDescriptionToggles();
}

document.addEventListener('shopify:section:load', (event) => {
  const target = event.target;
  if (target && target.querySelector) {
    bindProductDescriptionToggles(target);
  }
});

document.addEventListener('quick-view:loaded', () => {
  bindProductDescriptionToggles(document);
});
